<app-card-relatorio-laudo [titulo]="template.label" [status]="template.status">
  <div [ngClass]="{'hide-print': this.imgDocumento?.imprimir === false}">
    <div class="d-flex" >
      <a *ngIf="imgDocumento" rel="noopener noreferrer" target="_blank" [href]="imgDocumento.value"  class="p-2 bg-light">
        <img [src]="imgDocumento.value" alt="Documento" class="img-documento-proprietario">
        <div class="text-center p-1">{{ imgDocumento.label }}</div>
      </a>
    </div>
      <app-lista-titulo-desc [ngClass]="['d-block', 'w-100']" [elements]="template.elements" [cols]="6"></app-lista-titulo-desc>
  </div>
</app-card-relatorio-laudo>
